var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53299 22.0946H7.03995C8.97627 22.0946 11.215 20.337 11.215 18.0518V0H5.89024C3.4094 0 1.53299 1.52309 1.53299 4.16021V22.0946Z",
    fill: "#2F93FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4265 22.0946H17.9335C19.8698 22.0946 22.1092 20.337 22.1092 18.0518V0H16.7838C14.3022 0 12.4265 1.52309 12.4265 4.16021V22.0946Z",
    fill: "#EC3B56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4714 22.0946H28.9783C30.9147 22.0946 33.1541 20.337 33.1541 18.0518V0H27.829C25.3482 0 23.4718 1.52309 23.4718 4.16021L23.4714 22.0946Z",
    fill: "#4DCC71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51235 11.6875H0C0.42396 13.3284 2.42028 14.6181 4.6597 14.6181C6.71724 14.6181 9.50091 13.5041 9.50091 11.3947V7.58606H6.05149V11.3948C6.05149 12.5087 5.14357 13.3875 3.87263 13.3875C2.72339 13.3871 1.69424 12.6841 1.51235 11.6875Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.703 12.4497C31.703 13.3281 30.917 14.0315 29.8879 14.0315H22.2635V7.58569H29.8879C30.795 7.58569 31.5828 8.34774 31.5828 9.2269C31.5828 10.1053 30.7954 10.8677 29.8879 10.8677C30.917 10.8676 31.703 11.5709 31.703 12.4497ZM25.1676 10.516H27.528C28.1332 10.516 28.6777 9.98877 28.6777 9.40211C28.6777 8.81683 28.1332 8.28882 27.528 8.28882H25.1676V10.516ZM27.5885 13.3282C28.193 13.3282 28.7383 12.8009 28.7383 12.2149C28.7383 11.6289 28.1931 11.1016 27.5885 11.1016H25.1676V13.3278H27.5885V13.3282Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4403 12.9181V14.0314H14.6306C12.8155 14.0314 11.3025 12.5666 11.3025 10.8087C11.3025 9.05151 12.8155 7.58606 14.6306 7.58606H20.4403V8.75837C19.0485 8.46522 17.7163 8.28946 17.0509 8.28946C15.5992 8.28946 14.4495 9.40276 14.4495 10.8091C14.4495 12.2155 15.5992 13.3287 17.0509 13.3287C17.7163 13.328 19.0485 13.2113 20.4403 12.9181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.2509803704116c30762375966d30ce81.svg";
export { ForwardRef as ReactComponent };